export const environment = {

  production: true,

  defaultLanguage: 'en-GB',

  isDebugMode: false,

  firebase: {
    apiKey: 'AIzaSyASxWQ8whc3CrA6EXYII07d_xa3q27RVDc',
    authDomain: 'serendipity-f7626.firebaseapp.com',
    databaseURL: 'https://serendipity-f7626.firebaseio.com',
    projectId: 'serendipity-f7626',
    storageBucket: 'serendipity-f7626.appspot.com',
    messagingSenderId: '582668248299'
  },

  storageUriPrefix: 'https://firebasestorage.googleapis.com/v0/b/',

  version: '1.0.0-beta.1',

  sentryDsn: ''

};
